import {
  _delete, _get, _patch, _post, _save,
  getUrlQueryParameterFromObject,
} from 'frontcore/utils/communications/apiClient'
import { _saveBinary } from './apiClient'

export const URL_BASE_OK_FIRST_PART_CATEGORIES = 'ok-first-part-categories'
export const URL_BASE_OK_FIRST_PART_CHECK_POINTS = 'ok-first-part-check-points'
export const URL_BASE_OK_FIRST_PART_SCHEDULES = 'ok-first-part-schedules'
const URL_BASE_OK_FIRST_PART_ACHIEVE_RULES = 'ok-first-part-achieve-rules'
export const URL_BASE_OK_FIRST_PART_LAUNCH_REASONS = 'ok-first-part-launch-reasons'
export const URL_BASE_OK_FIRST_PART_ASSESSMENTS = 'ok-first-part-assessments'
export const URL_BASE_OK_FIRST_PART_SCHEDULE_ENTRY = 'entries'
export const URL_BASE_OK_FIRST_PART_BY_CHECKPOINT_LIST = 'ok-first-part-by-checkpoint-list'
export const URL_BASE_OK_FIRST_PART_BY_CHECKPOINT_DETAIL = 'ok-first-part-by-checkpoint-detail'
const OK_FIRST_PART_DATASETS_BASE_URL = 'stats/ok-first-part/datasets'
export const URL_BASE_OK_FIRST_PART_CHECK_POINTS_VERSIONS_GROUP = 'ok-first-part-check-point-version-groups'

export function getOkFirstPartCategories () {
  const url = `${URL_BASE_OK_FIRST_PART_CATEGORIES}/`
  return _get(url)
}

export function getOkFirstPartLaunchReasons () {
  const url = `${URL_BASE_OK_FIRST_PART_LAUNCH_REASONS}/`
  return _get(url)
}

export function getOkFirstPartCheckpointById ({ id, format = 'expanded' }) {
  let url = `${URL_BASE_OK_FIRST_PART_CHECK_POINTS}/${id}/`
  if (format == 'expanded') {
    url += '?format=expanded'
  }
  return _get(url)
}

export function getOkFirstPartAssessment (assessmentId) {
  const url = `${URL_BASE_OK_FIRST_PART_ASSESSMENTS}/${assessmentId}/?format=expanded`
  return _get(url)
}

export function downloadOkfirstpartExcelExample () {
  const url = `${URL_BASE_OK_FIRST_PART_CHECK_POINTS}/importer/example/`
  return _saveBinary(url)
}

export function loadOkfirstpartExcel (data) {
  const url = `${URL_BASE_OK_FIRST_PART_CHECK_POINTS}/importer/load/`
  return _post(url, data)
}

export function saveOkFirstPartCheckpoints (data) {
  const url = `${URL_BASE_OK_FIRST_PART_CHECK_POINTS}/`
  return _save(url, data, true)
}

export function editOkFirstPartCheckPoint (id, data) {
  const url = `${URL_BASE_OK_FIRST_PART_CHECK_POINTS}/${id}/`
  return _patch(url, data)
}

export function deleteOkFirstPartCheckPoint (id) {
  const url = `${URL_BASE_OK_FIRST_PART_CHECK_POINTS}/${id}/`
  return _delete(url)
}

export function duplicateOkFirstPartCheckPoint (id) {
  const url = `${URL_BASE_OK_FIRST_PART_CHECK_POINTS}/${id}/duplicate/`
  return _save(url, null, true)
}

export function createAchieveRule (data) {
  const url = `${URL_BASE_OK_FIRST_PART_ACHIEVE_RULES}/`
  return _save(url, data, true)
}

export function updateAchieveRule (achieveRule) {
  const url = `${URL_BASE_OK_FIRST_PART_ACHIEVE_RULES}/${achieveRule.id}/`
  return _patch(url, achieveRule)
}

export function deleteOKFirstPartAchieveRule (id) {
  const url = `${URL_BASE_OK_FIRST_PART_ACHIEVE_RULES}/${id}/`
  return _delete(url)
}

export function getOkFirstPartScheduleById (id) {
  const url = `${URL_BASE_OK_FIRST_PART_SCHEDULES}/${id}/?format=expanded`
  return _get(url)
}

export function deleteOkFirstPartSchedule (id) {
  const url = `${URL_BASE_OK_FIRST_PART_SCHEDULES}/${id}/`
  return _delete(url)
}

export function downloadPDF (scheduleId) {
  const url = `${URL_BASE_OK_FIRST_PART_SCHEDULES}/${scheduleId}/?format=pdf`
  return _saveBinary(url)
}

export function downloadOkFirstPartResults (scheduleId) {
  const url = `${URL_BASE_OK_FIRST_PART_SCHEDULES}/${scheduleId}/assessments_excel/`
  return _saveBinary(url)
}

export function getDatasetFinishedOkFirstPartByStatus (filters) {
  const keepFiltersWithNilValue = false
  const queryParams = getUrlQueryParameterFromObject(filters, keepFiltersWithNilValue)
  let url = `${OK_FIRST_PART_DATASETS_BASE_URL}/ofp-finished-by-status/`

  if (queryParams) {
    url += '?' + queryParams
  }

  return _get(url)
}

export function getDatasetActionStatus (filters) {

  const keepFiltersWithNilValue = false
  const queryParams = getUrlQueryParameterFromObject(filters, keepFiltersWithNilValue)
  let url = `${OK_FIRST_PART_DATASETS_BASE_URL}/actions-status/`

  if (queryParams) {
    url += '?' + queryParams
  }

  return _get(url)
}

export function getDatasetActionsExpiredOnDate (filters) {
  const keepFiltersWithNilValue = false
  const queryParams = getUrlQueryParameterFromObject(filters, keepFiltersWithNilValue)
  let url = `${OK_FIRST_PART_DATASETS_BASE_URL}/actions-expiration/`

  if (queryParams) {
    url += '?' + queryParams
  }

  return _get(url)
}

export function getOkFirstPartByCheckpointDetail (id) {
  const url = `${URL_BASE_OK_FIRST_PART_BY_CHECKPOINT_DETAIL}/${id}/`
  return _get(url)
}

export function getOkFirstPartByCheckpointTrendStats (payload) {
  const queryParams = getUrlQueryParameterFromObject(payload, false)
  const url = `${OK_FIRST_PART_DATASETS_BASE_URL}/historical-assessment/?${queryParams}`
  return _get(url)
}

export function getOkFirstPartCheckPointVersionsGroup (id) {
  const url = `${URL_BASE_OK_FIRST_PART_CHECK_POINTS_VERSIONS_GROUP}/${id}/`
  return _get(url)
}

export function editOkFirstPartCheckPointVersionsGroup (id, data) {
  const url = `${URL_BASE_OK_FIRST_PART_CHECK_POINTS_VERSIONS_GROUP}/${id}/`
  return _patch(url, data)
}
